module.exports = __webpack_public_path__ + "images/marketing/google-premier-partner-lrg.png";